<img [src]="widget?.imageSrc" alt="Alternate Text" />


